/**
 * Footer Year Update
 * Automatically updates the year in the footer
 */

(function() {
  'use strict';

  function updateFooterYear() {
    const yearElement = document.getElementById('footer-year');
    if (yearElement) {
      yearElement.textContent = new Date().getFullYear();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateFooterYear);
  } else {
    updateFooterYear();
  }
})();
